"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
i18next_1.default
    .use(react_i18next_1.initReactI18next) // passes i18n down to react-i18next
    .init({
    debug: true,
    saveMissing: true,
    /**
     * @TODO
     * the translations
     * (tip move them in a JSON file and import them,
     * or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
     */
    resources: {
        en: {
            translation: {
                'Search...': 'Search...',
                "Search for a user's name": "Search for a user's name",
            },
        },
        [(_c = (_b = (_a = window.pulse) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.languageCode]: {
            translation: (_e = (_d = window.pulse) === null || _d === void 0 ? void 0 : _d.globals) === null || _e === void 0 ? void 0 : _e.translations,
        },
    },
    lng: `${(_h = (_g = (_f = window.pulse) === null || _f === void 0 ? void 0 : _f.config) === null || _g === void 0 ? void 0 : _g.user) === null || _h === void 0 ? void 0 : _h.languageCode}`,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    react: {},
});
exports.default = i18next_1.default;
